var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#465072"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 15.6666H25.6666V18.9999H22.3333V15.6666ZM22.3333 22.3333H25.6666V32.3333H22.3333V22.3333ZM23.9999 7.33325C14.7999 7.33325 7.33325 14.7999 7.33325 23.9999C7.33325 33.1999 14.7999 40.6666 23.9999 40.6666C33.1999 40.6666 40.6666 33.1999 40.6666 23.9999C40.6666 14.7999 33.1999 7.33325 23.9999 7.33325ZM23.9999 37.3333C16.6499 37.3333 10.6666 31.3499 10.6666 23.9999C10.6666 16.6499 16.6499 10.6666 23.9999 10.6666C31.3499 10.6666 37.3333 16.6499 37.3333 23.9999C37.3333 31.3499 31.3499 37.3333 23.9999 37.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.ca9b4a93fb58cd70adc3a7c28759f044.svg";
export { ForwardRef as ReactComponent };